<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <article>
    <section class="call-stats__items" v-if="!loading">
      <p class="font-weight-bolder">Call Stats</p>

      <div class="row align-items-center">
        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PhoneIcon"
            color="info"
            :statistic="stats.booked"
            statistic-title="Total Booked In"
          ></statistic-card-vertical>
        </div>
        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PhoneIcon"
            color="info"
            :statistic="stats.completed"
            statistic-title="Total Completed"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PhoneIcon"
            color="info"
            :statistic="stats.total_booked_completed"
            statistic-title="Total Calls"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PauseIcon"
            color="info"
            :statistic="stats.total_pauses"
            statistic-title="Total Pauses"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PauseIcon"
            color="info"
            :statistic="stats.average_pauses.toFixed(1)"
            statistic-title="Average Pauses"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PhoneIcon"
            color="info"
            :statistic="stats.total_call_duration_mins"
            statistic-title="Total Call Duration (mins)"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PhoneIcon"
            color="info"
            :statistic="stats.average_call_duration_mins.toFixed(1)"
            statistic-title="Average Call Duration (mins)"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PhoneIcon"
            color="info"
            :statistic="stats.cancelledByVisitor"
            statistic-title="Total Cancelled By Caller"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="PhoneIcon"
            color="info"
            :statistic="stats.cancelledByPrison"
            statistic-title="Total Cancelled By Establishment"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="UserIcon"
            color="info"
            :statistic="stats.average_calls_per_user.toFixed(1)"
            statistic-title="Average Calls Per User"
          ></statistic-card-vertical>
        </div>

        <div :class="compareMode ? 'col-6' : 'col-4'">
          <statistic-card-vertical
            icon="UserIcon"
            color="info"
            :statistic="stats.total_unique_users"
            statistic-title="Total Unique Users"
          ></statistic-card-vertical>
        </div>

<!--        <div :class="compareMode ? 'col-6' : 'col-4'" v-if="stats.refunded">-->
<!--          <statistic-card-vertical-->
<!--            icon="PhoneIcon"-->
<!--            color="info"-->
<!--            :statistic="stats.total_funded_refunded"-->
<!--            statistic-title="Total refunded"-->
<!--          ></statistic-card-vertical>-->
<!--        </div>-->

<!--        <div :class="compareMode ? 'col-6' : 'col-4'" v-if="stats.refunded">-->
<!--          <statistic-card-vertical-->
<!--            icon="PhoneIcon"-->
<!--            color="info"-->
<!--            :statistic="stats.total_funded_not_refunded"-->
<!--            statistic-title="Total not refunded"-->
<!--          ></statistic-card-vertical>-->
<!--        </div>-->

<!--        <div :class="compareMode ? 'col-6' : 'col-4'" v-if="stats.refunded">-->
<!--          <statistic-card-vertical-->
<!--            icon="PhoneIcon"-->
<!--            color="info"-->
<!--            :statistic="stats.total_funded_cancellations"-->
<!--            statistic-title="Total Funded calls cancelled"-->
<!--          ></statistic-card-vertical>-->
<!--        </div>-->

      </div>
    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </article>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue';
  import BiStatsService from '../../../services/BiStatsService';

  export default {
    components: {
      StatisticCardVertical,
    },
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        loading: true,
        request: null,
        stats: null,
      };
    },
    computed: {
      ...mapState({
        compareMode: state => state.stats.compareMode,
        loaded: state => state.stats.loaded,
      }),
    },
    watch: {
      filters: {
        handler() {
          this.getCallStats();
        },
        deep: true,
      },
      loaded() {
        setTimeout(() => {
          this.getCallStats();
        });
      },
    },
    mounted() {
      if (this.loaded) {
        this.getCallStats();
      }
    },
    methods: {
      getCallStats() {
        this.loading = true;

        const promises = [
          this.getStatsOverview(),
        ];

        Promise.all(promises).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      getStatsOverview() {
        return BiStatsService.getVisitStatsOverview(this.filters).then(res => {
          this.stats = res.data;
        }).catch(err => {
          console.log('could not get stats', err);
          this.$toast.error('Could not get call stats, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
    },
  };
</script>
